import { DefineShipmentsTable } from './define-shipments-table/define-shipments-table';
import { useDefineShipmentsTableData, useMapSelectedOptionsForDropdown } from './hooks';

export const DefineShipmentsReadOnly = ({ stepPayload, selectedProducts }) => {
  const optionsForDropdown = useMapSelectedOptionsForDropdown(selectedProducts);
  const tableData = useDefineShipmentsTableData({
    stepPayload,
    isReadOnly: true,
  });

  return <DefineShipmentsTable data={tableData} getOptionsForDropdown={() => optionsForDropdown} isReadOnly />;
};
